export enum UploaderExternalIds {
  Filestack = 'filestack',
  TransloadIt = 'transloadit'
}

export enum UploaderSources {
  Filestack = 'filestack',
  Uppy = 'uppy',
  UppyUcs = 'uppy-ucs',
  UppyUcsDrive = 'uppy-ucs-drive',
  UppyUcsBox = 'uppy-ucs-box',
  UppyUcsDropbox = 'uppy-ucs-dropbox',
  UppyUcsUrl = 'uppy-ucs-url'
}
